import { useCallback, useMemo, useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useAlertsDispatchContext } from "@l2r-front/l2r-query"
import { I18N_NAMESPACE, UiModal } from "@l2r-front/l2r-ui"

import { useCatalogItemEditStateContext } from "./CatalogItemEditContext.hooks"
import { CatalogItemEditContextProvider } from "./CatalogItemEditContext.provider"

export const CatalogItemEditModal = (props) => {
    return <CatalogItemEditContextProvider>
        <CatalogItemEditModalContent {...props} />
    </CatalogItemEditContextProvider>
}

export const CatalogItemEditModalContent = (props) => {

    const {
        className,
        formTitle,
        typeTitle,
        FormComponent,
        open,
        onClose,
        ...otherProps
    } = props

    const [hasOngoingModifications, setHasOngoingModifications] = useState(false)
    const [mutationRunning, setMutationRunning] = useState(false)
    const { typeSelectionDisplayed, onBack } = useCatalogItemEditStateContext()

    const { setAlert } = useAlertsDispatchContext()
    const { t } = useTranslation(I18N_NAMESPACE)

    const BASIC_POPUP_HEIGHT = 575
    const FULL_POPUP_HEIGHT = 872
    const LOCATION_POPUP_HEIGHT = 666
    const POPUP_WIDTH = 600

    const popupHeight = useMemo(() => {
        const showLocation = !!otherProps.startingPosition
        const showDetails = !!typeTitle

        if (showLocation && showDetails) {
            return FULL_POPUP_HEIGHT
        } else if (showDetails) {
            return BASIC_POPUP_HEIGHT
        } else {
            return LOCATION_POPUP_HEIGHT
        }
    }, [otherProps.startingPosition, typeTitle])


    const handleClose = useCallback((checkModifications = true) => {
        if (checkModifications && hasOngoingModifications) {
            setAlert({
                alertTitle: t(I18N_NAMESPACE, "containers.catalogItemEditModal.alert.title"),
                cancelText: t(I18N_NAMESPACE, "containers.catalogItemEditModal.alert.cancelButton"),
                confirmText: t(I18N_NAMESPACE, "containers.catalogItemEditModal.alert.confirmButton"),
                callback: () => {
                    setHasOngoingModifications(false)
                    onClose()
                },
                severity: "warning",
            })
        } else {
            setHasOngoingModifications(false)
            onClose()
        }
    }, [hasOngoingModifications, onClose, setAlert, t])

    const handleMutationRunning = useCallback((isRunning) => {
        setMutationRunning(isRunning)
    }, [])

    return <UiModal
        title={typeSelectionDisplayed ? typeTitle : formTitle}
        id="campaign-edit-modal"
        className={className}
        open={open}
        onClose={handleClose}
        showLoader={mutationRunning}
        handleBack={typeSelectionDisplayed ? onBack : null}
        height={popupHeight}
        width={POPUP_WIDTH}
    >
        <FormComponent close={handleClose} onChange={setHasOngoingModifications} onMutationRunning={handleMutationRunning}{...otherProps} />
    </UiModal>
}

CatalogItemEditModal.propTypes = {
    className: PropTypes.string,
    formTitle: PropTypes.string.isRequired,
    typeTitle: PropTypes.string,
    FormComponent: PropTypes.elementType.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
}
